// 顶部
import Top from './components/top.vue'
// 阀门列表
import FMList from './components/fmList.vue'
// 摄像头图片
import PicList from './components/picList.vue'
// RTU列表
import RTUList from './components/rtuList2'
// 传感器列表
import CgqList from './components/cgq'
// 第三方摄像头列表
import VideoList from './components/videoList'
import Panel from './components/Panel.vue'
import { ImagePreview } from 'vant'
import AI from '@/components/AI'
let timerDeviceStateTimer = null

export default {
  components: {
    Panel,
    FMList,
    RTUList,
    PicList,
    Top,
    CgqList,
    VideoList,
    AI,
  },

  data() {
    return {
      no: localStorage.getItem('no') ? localStorage.getItem('no') : '', // 记录的设备号
      ishow: false, // 是否侧滑 打开抽屉
      des: 0, // 当前控制器在控制器列表中的 index 下标
      choselist: {}, // 当前展示的设备
      devicelist: '', // 所有设备
      fullheight: document.documentElement.clientHeight,
      voltage: 0, // 电压值
      solarVoltage: null, // 太阳能电压
      retime: '', // 最新更新时间
      type: '', // 设备类型，1：网关，2：气象站，3：摄像头图片，4：控制器,5：第三方摄像头, 6：RTU解码器  7:第二代气象站
      online: '', //  设备在线情况 online offline
      hasDeviceChange: false,
      cgqInfo: {}, // 传感器的一些信息
      cardTriger: 'card', // 列表展示形式，card 卡片  list 一行
      refreshing: false, // 触发下拉刷新
      imgList: [],
      visible: false,
      url: '',
      time: '',
      collapse: [],

      cardType: 'list',
    }
  },
  async mounted() {
    // 查询设备列表
    await this.getDeviceList()
    // 查询设备在线的装备
    await this.getDeviceOnline(this.no)
    // 请求图片列表
    await this.getPicture()
  },

  destroyed() {
    // 卸载清除掉定时器
    // 清除获取设备在线状态定时
    clearInterval(timerDeviceStateTimer)
    // 清除阀门定时的定时器
    this.valist &&
      Array.isArray(this.valist) &&
      this.valist.length &&
      this.valist.map((item) => {
        if (item.timer) {
          clearInterval(item.timer)
        }
      })

    // 图片
    this.imgList = []
  },

  methods: {
    handleIcon(type) {
      this.cardType = type
    },

    handleCamera() {
      this.$router.push(`/camera?type=${this.type}`)
    },
    hadnleToGatewayLog() {
      this.$router.push('/gatewayLog')
    },

    // 获取摄像头下的图片列表
    async getPicture() {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        forbidClick: true,
        duration: 0,
      })

      try {
        this.isFirst = false
        const { page, pageSize } = this
        const res = await this.$api.getCameraPicture({
          gatewayNo: localStorage.getItem('no'),
          page: 1,
          pageSize: 2,
        })
        this.$toast.clear()

        let list = res.list

        if (list && list.length) {
          this.imgList = [...list].slice(0, 2).filter((o) => o)
        } else {
          this.imgList = []
        }
      } catch (err) {
        this.imgList = []
        this.$toast.clear()
        console.error(err)
      }
    },

    // 查看设备的在线情况
    getDeviceOnline(no) {
      if (this.choselist.type === 2 || this.choselist.type === 7) return false
      clearInterval(timerDeviceStateTimer)
      this.$api.getDeviceOnlineState({ no }).then((res) => {
        if (res.errcode === 0) {
          this.online = res.state === 'online' ? true : false
        } else {
          this.$toast(res.errmsg)
        }
      })

      // 3秒 轮训一次设备状态接口
      timerDeviceStateTimer = setInterval(() => {
        this.getDeviceOnline(this.no)
      }, 1000 * 3)
    },

    // 展示设备侧滑层
    showEquiment() {
      this.ishow = true
      this.$refs.deviceList.setDeviceList(
        this.choselist,
        this.devicelist,
        this.des,
      )
    },

    // 关闭设备层
    async closeEquiment(no) {
      console.log('选择设备:', no)

      this.ishow = false
      var des = this.des
      var devicelist = this.devicelist
      var choselist = ''
      await localStorage.setItem('no', no)
      this.no = no
      if (!this.$isblank(devicelist)) {
        if (this.$isblank(no)) {
          des = 0
        } else {
          for (var i = 0; i < devicelist.length; i++) {
            if (devicelist[i].no == no) {
              des = i
            }
          }
        }
        choselist = devicelist[des]
        this.choselist = choselist
        this.des = des
        this.$refs.deviceList.setDeviceList(choselist, devicelist, des)
        this.type = choselist.type

        // 查询设备在线状态
        this.getDeviceOnline(no)
        // 请求图片
        this.getPicture()

        // 通知子组件 有切换设备
        this.hasDeviceChange = true
        setTimeout(() => {
          // 将状态重置
          this.hasDeviceChange = false
        }, 100)
      }
    },

    hanleCardChange(value) {
      this.cardTriger = value
    },

    /**
     * @description 报警阈值  /  阀门定时设置  / RTU定时设置
     * @param {*} item 数据
     * @param {*} type 类型  0 传感情的报警阀值  1 阀门定时器  2 RTU定时器
     */
    seThres(item, type) {
      sessionStorage.setItem(
        'liveSettingData',
        JSON.stringify({ ...item, no: this.no, voltage: this.voltage }),
      )
      this.$router.push({
        path: '/liveSetting',
        query: {
          type: 'cgq',
        },
      })
    },

    // 查询左侧抽屉的设备列表 其实就是控制器（网关）
    async getDeviceList() {
      this.$toast.loading({
        message: this.$t('live.read_loading'),
        forbidClick: true,
        duration: 0,
      })

      const _this = this
      await this.$api
        .getDeviceList({})
        .then((res) => {
          this.$toast.clear()
          if (res.errcode === 0) {
            var des = _this.des
            var no = _this.no

            var devicelist = res.data
            var choselist = ''
            // 判断返回结果的 控制器列表是否为空
            if (!_this.$isblank(devicelist)) {
              // 如果no 不存在 则取第一个
              if (_this.$isblank(no)) {
                des = 0
              } else {
                //   遍历确认当前选中的控制器的 index 下标
                // des = devicelist.findIndex(o => o.no == no);
                for (var i = 0; i < devicelist.length; i++) {
                  if (devicelist[i].no == no) {
                    des = i
                  }
                }
              }
              //   当前控制器的信息
              choselist = devicelist[des]
              this.no = choselist.no

              localStorage.setItem('no', choselist.no)

              _this.choselist = choselist
              _this.des = des
              _this.devicelist = devicelist
              //   调用抽屉组件的方法 setDeviceList 将控制器列表数据保存下来 并将no 存在localS
              _this.$refs.deviceList.setDeviceList(choselist, devicelist, des)

              this.type = choselist.type
            } else {
              // 没有设备列表
              _this.$refs.pageToast.type = 1
            }
          } else {
            // 其他异常
            _this.$toast(this.$t('common.nodata'))
          }
        })
        .catch((err) => {
          this.$toast.clear()
          console.log(err)
          // 其他异常
          _this.$toast(this.$t('common.timeout'))
        })
    },

    // 传感器list组件中请求列表中带回的头部监控数据
    getTopData(obj) {
      const { solarVoltage = null, voltage, retime = null } = obj
      this.solarVoltage = solarVoltage
      this.voltage = voltage
      this.retime = retime

      this.cgqInfo = { ...obj }
    },

    // 下拉刷新回调
    refreshCallback() {
      console.log('下拉刷新')
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
      }, 100)
    },

    // 查看所有图片
    handleViewPic() {
      this.$router.push('/pictures')
    },

    // 查看当钱图片
    handleImgClick(data, index) {
      this.url = data.url

      let urls = [
        'https://api.ascod.cn/iotUser-api/camera/20210909/20210909083503.jpg',
        'https://api.ascod.cn/iotUser-api/camera/20210909/20210909083508.jpg',
        'https://api.ascod.cn/iotUser-api/camera/20210909/20210909083454.jpg',
        'https://app01.ascod.cn/static/test/20211021090647.jpg',
        'https://app01.ascod.cn/static/test/20211021090643.jpg',
        'https://app01.ascod.cn/static/test/20211021090609.jpg',

        'https://api.ascod.cn/static-camera/20211209/20211209134121.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134147.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134130.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134126.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134137.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134107.jpg',
        'https://api.ascod.cn/static-camera/20211209/20211209134142.jpg',
      ]

      this.$router.push({
        path: '/ai',
        query: {
          imgUrl: data.url,
          time: this.time,
          fileId: data.fileId,
        },
      })
    },

    handleCancel() {
      this.visible = false
    },
  },
}
